import { EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import { ASC, DESC } from 'NewAngular/constants/core.constants';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
import * as i2 from "@angular/common";
const _c0 = ["ycn-folderable-column-headers", ""];
const _c1 = ["*"];
const _c2 = a0 => ({ "pointer-events": a0 });
const _forTrack0 = ($index, $item) => $item.value;
function FolderableColumnHeadersComponent_For_2_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "th", 2);
    i0.ɵɵlistener("click", function FolderableColumnHeadersComponent_For_2_Template_th_click_0_listener() { const col_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.setSortBy(col_r2)); });
    i0.ɵɵelementStart(1, "span", 3);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "titlecase");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const col_r2 = ctx.$implicit;
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(5, _c2, col_r2.disabled ? "none" : "auto"))("ngClass", col_r2.cssClasses);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 3, col_r2.label));
} }
// The number of columns used when drawing a column header element's contents.
const CSS_GRID_COL_NUM = 11;
/**
 * Component for headers of columns in folder item list.
 * - Shows column names in a row.
 * - Used to manage the sort column and direction.
 *
 * Notes
 * - The selector is wrapped in [] to avoid creating an extra element that interferes with css layout.
 */
export class FolderableColumnHeadersComponent {
    /**
     * Create a list of items to render as column headers.
     * - Determine css classes for each header.
     */
    get columns() {
        if (Object.keys(this.columnConfig).length > CSS_GRID_COL_NUM) {
            throw new Error('Too many columns. There is not enough space to render all columns.');
        }
        return Object.entries(this.columnConfig).map(([colValue, config], index) => {
            const { label, numCssCols, defaultSortDirection } = config;
            const cssClasses = {
                'th': true,
                'th-sort': true,
                'th-sort-asc': colValue === this.sortColumn && this.sortDirection === ASC,
                'th-sort-desc': colValue === this.sortColumn && this.sortDirection === DESC,
            };
            // Let the first column expand to take up any extra remaining columns in the css column grid.
            if (index === 0) {
                cssClasses['col-auto'] = true;
                cssClasses['file-td-name'] = true;
            }
            else {
                cssClasses[`col-${numCssCols}`] = true;
            }
            // Assume if a column is not in the sortableColumns, it is display-only and should be disabled.
            const disabled = !Object.values(this.sortableColumns).includes(colValue);
            return {
                value: colValue,
                label,
                cssClasses,
                defaultSortDirection,
                disabled,
            };
        });
    }
    constructor(store) {
        this.store = store;
        this.setSort = new EventEmitter();
    }
    ngAfterViewInit() {
        if (!this.setSortAction && !this.setSort.observed) {
            throw new Error('Column sort selection must be handled. If sort is stored in NgRx, provide `setSortAction`. ' +
                'If sort is handled by ancestor component, observe`setSort`.');
        }
    }
    setSortBy(column) {
        if (!Object.values(this.sortableColumns).includes(column.value))
            return;
        // Flip the sort direction if the same column was clicked again
        let sortDirection = column.defaultSortDirection;
        if (column.value === this.sortColumn) {
            sortDirection = this.sortDirection === ASC ? DESC : ASC;
        }
        const sort = {
            sortColumn: column.value,
            sortDirection,
        };
        if (this.setSortAction) {
            this.store.dispatch(this.setSortAction(sort));
        }
        if (this.setSort.observed) {
            this.setSort.emit(sort);
        }
    }
}
FolderableColumnHeadersComponent.ɵfac = function FolderableColumnHeadersComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FolderableColumnHeadersComponent)(i0.ɵɵdirectiveInject(i1.Store)); };
FolderableColumnHeadersComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FolderableColumnHeadersComponent, selectors: [["", "ycn-folderable-column-headers", ""]], inputs: { columnConfig: "columnConfig", sortColumn: "sortColumn", sortableColumns: "sortableColumns", sortDirection: "sortDirection", setSortAction: "setSortAction" }, outputs: { setSort: "setSort" }, standalone: false, attrs: _c0, ngContentSelectors: _c1, decls: 4, vars: 0, consts: [[1, "tr"], [1, "th-sort", 3, "ngStyle", "ngClass"], [1, "th-sort", 3, "click", "ngStyle", "ngClass"], [1, "pb-10"]], template: function FolderableColumnHeadersComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "tr", 0);
        i0.ɵɵrepeaterCreate(1, FolderableColumnHeadersComponent_For_2_Template, 4, 7, "th", 1, _forTrack0);
        i0.ɵɵprojection(3);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵrepeater(ctx.columns);
    } }, dependencies: [i2.NgClass, i2.NgStyle, i2.TitleCasePipe], encapsulation: 2 });
